// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2-Mr8","container":"styles_container__142nz","icon":"styles_icon__3z2QJ","text":"styles_text__PRbpj","dropdownWrapper":"styles_dropdownWrapper__3VH9u"};